import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { getArticleById } from '../../actions/article';

const Article = ({ getArticleById, article: { article, loading }, match }) => {
  return <div></div>;
};

Article.propTypes = {
  getArticleById: PropTypes.func.isRequired,
  article: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  article: state.article
});

export default connect(mapStateToProps, { getArticleById })(Article);
